var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconConnectionsSideMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.89714 9.19491C2.04823 9.65443 -0.177538 10.5927 1.17811 11.7668C1.84033 12.3404 2.57787 12.7506 3.50514 12.7506H8.79636C9.72363 12.7506 10.4612 12.3404 11.1234 11.7668C12.479 10.5927 10.2533 9.65443 9.40437 9.19491C7.4137 8.11734 4.8878 8.11734 2.89714 9.19491Z",
    stroke: "#CECDFF",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.85088 3.47741C8.85088 4.98371 7.64199 6.20481 6.15075 6.20481C4.65951 6.20481 3.45062 4.98371 3.45062 3.47741C3.45062 1.9711 4.65951 0.75 6.15075 0.75C7.64199 0.75 8.85088 1.9711 8.85088 3.47741Z",
    stroke: "#CECDFF",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.15088 16.3477C3.15088 20.3284 6.37046 23.548 10.3512 23.548L9.32261 21.4908",
    stroke: "#CECDFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3512 9.14957C22.3512 5.16881 19.1316 1.94922 15.1509 1.94922L16.1795 4.00646",
    stroke: "#CECDFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0983 21.1949C15.2494 21.6544 13.0236 22.5927 14.3793 23.7668C15.0415 24.3404 15.779 24.7506 16.7063 24.7506H21.9975C22.9248 24.7506 23.6623 24.3404 24.3246 23.7668C25.6802 22.5927 23.4544 21.6544 22.6055 21.1949C20.6149 20.1173 18.089 20.1173 16.0983 21.1949Z",
    stroke: "#CECDFF",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0521 15.4774C22.0521 16.9837 20.8432 18.2048 19.3519 18.2048C17.8607 18.2048 16.6518 16.9837 16.6518 15.4774C16.6518 13.9711 17.8607 12.75 19.3519 12.75C20.8432 12.75 22.0521 13.9711 22.0521 15.4774Z",
    stroke: "#CECDFF",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconConnectionsSideMenu);
export default __webpack_public_path__ + "static/media/icon-connections-side-menu.e01a44c6bc8a5165239acaa553fb5121.svg";
export { ForwardRef as ReactComponent };